import { render, staticRenderFns } from "./SlideSidebar.vue?vue&type=template&id=740cde4a&scoped=true"
import script from "./SlideSidebar.vue?vue&type=script&lang=js"
export * from "./SlideSidebar.vue?vue&type=script&lang=js"
import style0 from "./SlideSidebar.vue?vue&type=style&index=0&id=740cde4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740cde4a",
  null
  
)

export default component.exports